import { ForaLogo } from '../../../assets/icons';
import { Flex } from '../../Layout';
import { Text } from '../../Text';

export type EServiceLogoProps = {
  eServiceText: string;
};

export const LogoWithEServiceText = ({ eServiceText = '/ E-tjänst' }: EServiceLogoProps) => {
  return (
    <Flex height={28} alignItems="baseline" columnGap={20}>
      <ForaLogo width={100} />
      <Text renderAs="span" color="white" style={{ fontSize: '14px' }}>
        {eServiceText}
      </Text>
    </Flex>
  );
};
